import { type Control, Controller } from 'react-hook-form';
import {
  Stack,
  Typography,
  FormControl,
  TextField,
  FormHelperText,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';
import { getFormErrorAttributes } from '#apps/client-web/app/helpers/react-hook-form';

export type LightingFieldsProps = {
  control: Control<EditAuditFormBackgroundData>;
  disableForm: boolean;
};

export const LightingFields = ({
  control,
  disableForm,
}: LightingFieldsProps) => {
  return (
    <Accordion variant="outlined">
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header">
        <Stack direction="row" alignItems="center" spacing={1}>
          <LightbulbIcon fontSize="small" />
          <Typography variant="body1">Lighting</Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={3}>
          <Controller
            control={control}
            name="lighting.exteriorLightingControls"
            disabled={disableForm}
            rules={{ maxLength: 120 }}
            render={({ field, fieldState }) => (
              <FormControl
                fullWidth
                {...getFormErrorAttributes(fieldState.error)}>
                <TextField
                  {...field}
                  label="Exterior lighting controls"
                  type="text"
                  multiline
                  rows={2}
                  variant="outlined"
                  {...getFormErrorAttributes(fieldState.error)}
                />
                <FormHelperText>{fieldState.error?.message}</FormHelperText>
              </FormControl>
            )}
          />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
